/**
 * @fileoverview Domain types for the class-wide Development Report (AR-545).
 *
 * The backend (GET /api/arc_mosaico/new_report/curriculum) returns two
 * curriculum trees — `content` (Standards) and `skills` — each a fixed 4-level
 * hierarchy. We normalize both into a single recursive `ReportNode` shape so the
 * tree components stay agnostic of the original level.
 */

export type ReportType = 'standards' | 'skills'

/** A class (turma) shown in the report's class filter. */
export interface ReportClass {
  readonly id: string
  readonly name: string
}

/** Recursive curriculum node (lv2/lv3 = branch with children, lv4 = leaf). */
export interface ReportNode {
  readonly id: string
  readonly name: string
  /** Standard/skill code(s), shown in bold before the name on leaves. */
  readonly originalCodes: string
  /** Rounded average grade (1-5) — only meaningful on assessed leaves. */
  readonly average: number | null
  readonly children: ReportNode[]
}

/** Top-level curriculum framework (lv1) — carries color and assessment flag. */
export interface ReportLv1 {
  readonly id: string
  readonly name: string
  readonly color: string
  readonly hasAssessment: boolean
  readonly children: ReportNode[]
}

/** Full normalized payload consumed by the page. */
export interface CurriculumReport {
  readonly standardsAssessed: number
  readonly skillsAssessed: number
  readonly standards: ReportLv1[]
  readonly skills: ReportLv1[]
}

export const ALL_CLASSES = '' as const
